// app/javascript/compcalc/components/AppDrawer.jsx

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';

import AppMenuListItems from './AppMenuListItems';

const styles = {
  list: {
    width: 'auto',
  },
  // paper: this.props.classes.drawerPaper,
};

class AppDrawer extends React.PureComponent {

  constructor(props) {
    super(props);
    // console.log("toggleDrawer:", props.toggleDrawer);
    // this.state = { isOpen: props.isDrawerOpen };
  }

  close = () => {
    // console.log("AppDrawer.close()");
    this.props.toggleDrawer(false);
  }

  render() {
    const { classes } = this.props;

    const contentList = (
      <div className={classes.list}>
        <List component="nav">{AppMenuListItems(this.props)}</List>
      </div>
    );

    return (
      <Drawer anchor="left" open={this.props.isDrawerOpen} onClose={this.close}>
        <div
          tabIndex={0}
          role="button"
          onClick={this.close}
          onKeyDown={this.close}
        >
          {contentList}
        </div>
      </Drawer>
    );
  }
}

AppDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  isDrawerOpen: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  drawerIndex: PropTypes.number.isRequired,
  drawerIndexChanged: PropTypes.func.isRequired,
};

export default withStyles(styles)(AppDrawer);
